/* eslint-disable @typescript-eslint/no-explicit-any */
import { getImpuestoEmpresaNew } from "api/ImpuestoEmpresa.service"
import { useUsuarioEmpresas } from "api/Usuario.hook"
import { useEffect, useState } from "react"
import { impuestoOcrAdapter } from "../utils/impuestoOcr.adapter"

interface ImpuestoRetencionValueProps {
  id: string
  valor: number
  valorLabel: string
}
interface ImpuestoRetencionProps {
  label: string
  value: ImpuestoRetencionValueProps
  tipo: string
}

export const useOcrTaxes = ({ ...props }) => {
  const [impuestos, setImpuestos] = useState<Array<ImpuestoRetencionProps>>([])
  const {
    usuarioEmpresas: { items: ownCompanies },
  } = useUsuarioEmpresas()

  const empresaCreacion = () => {
    const librador = () => {
      const libradorExist = ownCompanies?.find(
        (empresa: $TSMigrationFixMe) => empresa.nif === props.values.libradorNif
      )
      return libradorExist ? { ...libradorExist, is: "librador" } : null
    }
    const librado = () => {
      const libradoExist = ownCompanies?.find(
        (empresa: $TSMigrationFixMe) => empresa.nif === props.values.libradoNif
      )
      return libradoExist ? { ...libradoExist, is: "librado" } : null
    }
    switch (true) {
      case librador()?.verificada:
        return librador()
      case librado()?.verificada:
        return librado()
      default:
        return librado() ?? librador()
    }
  }
  const isProvider = empresaCreacion()?.is === "librador"
  const isClient = empresaCreacion()?.is === "librado"

  useEffect(() => {
    const sortedResponse = ({ response, type }: $TSMigrationFixMe) =>
      response
        ?.flatMap(
          (impuesto: $TSMigrationFixMe) => impuestoOcrAdapter(impuesto)?.[type]
        )
        ?.filter((impuesto: $TSMigrationFixMe) =>
          impuesto &&
          Boolean(props.values.libradoNif === empresaCreacion()?.nif)
            ? impuesto?.tipo === "Compra"
            : impuesto?.tipo === "Venta"
        )
        ?.sort(
          (a: $TSMigrationFixMe, b: $TSMigrationFixMe) =>
            b?.value?.valor - a?.value?.valor
        )

    empresaCreacion()?.id
      ? getImpuestoEmpresaNew({
          EsActivo: true,
          EmpresaId: empresaCreacion()?.id,
          IsPagingEnabled: false,
        }).then(({ items }) => {
          setImpuestos(sortedResponse({ response: items, type: "impuestos" }))
          props.setFieldValue(
            "listaImpuestos",
            sortedResponse({ response: items, type: "impuestos" })
          )
          props.setFieldValue(
            "impuestos.0.porcentaje",
            sortedResponse({ response: items, type: "impuestos" })?.find(
              ({ value }: $TSMigrationFixMe) =>
                value?.valor === props.values.impuestos[0]?.porcentaje?.valor
            )?.value ??
              sortedResponse({ response: items, type: "impuestos" })?.find(
                ({ value }: $TSMigrationFixMe) => value?.valor === 21
              )?.value ?? {
                id: null,
                valor: null,
              }
          )
          props.setFieldValue("empresaCreacionId", empresaCreacion()?.id)
          props.setFieldValue("empresaCreacion", empresaCreacion())
          props.setFieldValue(
            "listaRetenciones",
            sortedResponse({ response: items, type: "retenciones" })
          )
        })
      : props.setFieldValue("listaImpuestos", []) &&
        props.setFieldValue("impuestos.0.porcentaje", {
          id: null,
          valor: null,
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.values?.libradoNif, props.values?.libradorNif])

  return { impuestos, isClient, isProvider, empresaCreacion }
}
